/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { AuthProvider as ContextProvider } from 'data';

function AuthProvider({ children = null }) {
  const [currentRole, setCurrentRole] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const getLocation = () => location;

  const redirect = (to, state) => {
    navigate(to, { replace: true, state });
  };

  return (
    <ContextProvider
      value={{
        redirect,
        getLocation,
        setCurrentRole,
        currentRole,
      }}
    >
      {children}
    </ContextProvider>
  );
}

export default AuthProvider;
